export const GET_CLAIM_REQUESTS = "GET_CLAIM_REQUESTS";
export const UPDATE_CLAIM_REQUEST_STATUS = "UPDATE_CLAIM_REQUEST_STATUS";
